var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball d-flex align-items-center justify-content-center",style:(_vm.bgStyle)},[_c('div',[_c('p',{staticClass:"ball-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"m-0 text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }